import DragHandleIcon from "@material-ui/icons/DragHandle";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Chip from "@material-ui/core/Chip";
import AuthorizationWrapper from "../../AuthorizationWrapper";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import articlesStore from "../../../store/articles/ArticlesStore";
import withIntl from "../../../utils/withIntl";
import EditSwitch from "../../EditArticle/EditSwitch";
import { Grid } from "@material-ui/core";
import cloudStore from "../../../store/CloudStore";
import { updateModifiergroups } from "../../../store/articles/ModifiergroupsApi";
import { useDialog } from "../../Dialogs/DialogProvider";
import ModifierarticleDetailsDialog from "./ModifierarticleDetailsDialog";
import Typography from "@material-ui/core/Typography";
import GetCurrency from "../../../helper/GetCurrency";
import { getTranslationValue } from "../../../store/articles/ArticlesHelpers";
import EditTextField from "../../EditArticle/EditTextField";
import { updateModifierarticles } from "../../../store/articles/ModifierarticlesApi";
import ActionButtonModifierarticle from "../ActionButtons/ActionButtonModifierarticle";
import { updateArticle } from "../../../store/articles/ArticlesApi";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    width: "100%",
    margin: 5,
    paddingTop: 5,
    // backgroundColor: "pink",
  },
  rootChip: { fontSize: 10, padding: 1 },
  sizeSmall: { height: 16 },
  // section: { border: "2px solid black" },
});

function ModifierarticleDraggable(props) {
  const classes = useStyles();
  const [openDialog] = useDialog();
  const modifierarticle = articlesStore.modifierarticles[props.modifierarticleId];

  const removeModifierarticleFromGroup = () => {
    let modifierarticleIds = [...props.modifiergroup.modifierarticleIds];
    let index = modifierarticleIds.indexOf(modifierarticle.id);
    modifierarticleIds.splice(index, 1);
    return updateModifiergroups(
      cloudStore.merchant.id,
      [props.modifiergroup],
      [
        {
          modifierarticleIds: modifierarticleIds,
        },
      ]
    );
  };

  const handleOpenEditModifierArticle = () => {
    openDialog({
      children: (
        <ModifierarticleDetailsDialog
          removeModifierarticleFromGroup={removeModifierarticleFromGroup}
          setSearchValue={props.setSearchValue}
          fullWidth={true}
          modifierarticle={modifierarticle}
          articleId={props.articleId}
          currentLanguage={props.currentLanguage}
          setCurrentLanguage={props.setCurrentLanguage}
        />
      ),
      fullWidth: true,
      maxWidth: "sm",
    });
  };

  return (
    <div ref={props.provided.innerRef} {...props.provided.draggableProps}>
      <Grid className={classes.section} item xs={2} sm={1} md={1}>
        {!props.hideDragHandles && (
          <AuthorizationWrapper
            permission={"_"}
            child={
              <ListItemIcon {...props.provided.dragHandleProps} style={{ cursor: "move" }}>
                <DragHandleIcon />
              </ListItemIcon>
            }
          />
        )}
      </Grid>
      <Grid className={classes.root} container alignItems={"center"} spacing={1}>
        <Grid className={classes.section} alignItems={"center"} item xs={8} sm={4} md={3}>
          <Typography
            style={
              props.currentLanguage === cloudStore.merchant.default_language
                ? { color: "black" }
                : modifierarticle.translation_id != null &&
                  articlesStore.translations[modifierarticle.translation_id][props.currentLanguage] != null
                ? { color: "black" }
                : { color: "lightgray" }
            }
          >
            {getTranslationValue(
              "name",
              "translation_id",
              props.currentLanguage,
              modifierarticle,
              modifierarticle.name
            )}
          </Typography>
        </Grid>
        <Grid className={classes.section} alignItems={"center"} item xs={3} sm={2} md={1}>
          <Typography>{GetCurrency() + " " + (modifierarticle.price / 100).toFixed(2)}</Typography>
        </Grid>
        <Grid className={classes.section} item xs={3} sm={1} md={1}>
          <AuthorizationWrapper
            permission={"modifierarticle.id"}
            child={
              <Chip
                classes={{ root: classes.rootChip, sizeSmall: classes.sizeSmall }}
                variant="outlined"
                label={"ID: " + modifierarticle.id}
                size="small"
                color="primary"
              />
            }
          />
        </Grid>
        <Grid className={classes.section} item xs={3} sm={2} md={2}>
          <AuthorizationWrapper
            permission={"modifierarticle.plu"}
            child={
              <Chip
                classes={{ root: classes.rootChip, sizeSmall: classes.sizeSmall }}
                variant="outlined"
                label={"PLU: " + modifierarticle.plu}
                size="small"
                color="primary"
              />
            }
          />
          <AuthorizationWrapper
            permission={"article.plu_hubrise"}
            child={
              <EditTextField
                key={modifierarticle.plu}
                label={props.intl.formatMessage({ id: "PLU" })}
                value={modifierarticle.plu === null ? "" : modifierarticle.plu}
                placeholder={modifierarticle.plu}
                onBlur={(value, setBeginValue) => {
                  let newValue = value === "" ? null : value;
                  if (newValue != null) {
                    updateModifierarticles(articlesStore.merchantId, [modifierarticle], [{ plu: value }]).then(() =>
                      setBeginValue(value)
                    );
                  }
                }}
                variant={"standard"}
              />
            }
          />
        </Grid>
        <Grid className={classes.section} item xs={3} sm={2} md={1}>
          <EditSwitch
            key={modifierarticle.key}
            authorizationField={"modifierarticle.manual_active"}
            value={!!modifierarticle.manual_active && !!modifierarticle.active}
            disabled={!modifierarticle.active && cloudStore.merchant?.merchantable_type != null}
            onChange={(newValue, setBeginValue) => {
              updateModifierarticles(
                articlesStore.merchantId,
                [modifierarticle],
                [{ manual_active: newValue, active: true }]
              ).then(() => setBeginValue(newValue));
            }}
          />
        </Grid>

        <Grid xs={1} sm={1} md={1}>
          <ActionButtonModifierarticle
            handleOpenEditModifierArticle={handleOpenEditModifierArticle}
            removeModifierarticleFromGroup={removeModifierarticleFromGroup}
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default withIntl(ModifierarticleDraggable);
